import { gql } from '@apollo/client';

export const DELETE_GHOST_ACCESS = gql`
    mutation DeleteGhostAccess {
        deleteGhostAccess
    }
`;
